import { render, staticRenderFns } from "./PlanActionDetailView.vue?vue&type=template&id=182a8606&scoped=true&"
import script from "./PlanActionDetailView.vue?vue&type=script&lang=js&"
export * from "./PlanActionDetailView.vue?vue&type=script&lang=js&"
import style0 from "./PlanActionDetailView.vue?vue&type=style&index=0&id=182a8606&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182a8606",
  null
  
)

export default component.exports